<template>
  <div :key="gtin">
    <!-- Injecting css in shadow dom -->
    <component :is="'style'">
      {{ extraCss }}
    </component>

    <template v-if="error">
      <slot class="inner-container" />
    </template>

    <template v-else>
      <template v-if="type === 'Popup'">
        <span
          class="vendie-wtb-button"
          @click="togglePopup"
          data-cy="vendie-wtb-button"
        >
          {{ settings.whereToBuyText }}
        </span>
        <products-popup :is-active="showPopup" @on-close="togglePopup">
          <products-popup-item
            v-for="(
              { stock, price, logo, goUrl, name }, index
            ) in productsLimited"
            :key="index"
            :name="name"
            :price="price"
            :showPrice="settings.showPrice"
            :stock="stock"
            :logo="logo"
            :goUrl="`${goUrl}&cid=${cid}`"
            :inStockText="settings.inStockText"
            :outOfStockText="settings.outOfStockText"
            :currencySymbol="settings.currencySymbol"
          />
        </products-popup>
      </template>

      <template v-if="type === 'Remote popup'">
        <products-popup
          :is-active="showRemotePopup"
          @on-close="toggleRemotePopup"
        >
          <products-popup-item
            v-for="(
              { stock, price, logo, goUrl, name }, index
            ) in productsLimited"
            :key="index"
            :name="name"
            :price="price"
            :showPrice="settings.showPrice"
            :stock="stock"
            :logo="logo"
            :goUrl="`${goUrl}&cid=${cid}`"
            :inStockText="settings.inStockText"
            :outOfStockText="settings.outOfStockText"
            :currencySymbol="settings.currencySymbol"
          />
        </products-popup>
      </template>

      <template v-if="type === 'Local popup'">
        <span
          class="vendie-wtb-button"
          @click="togglePopup"
          data-cy="vendie-wtb-button"
        >
          {{ settings.whereToBuyText }}
        </span>
        <local-products-popup :is-active="showPopup" @on-close="togglePopup">
          <local-online-offline-tab
            v-if="localIsLoaded"
            :state="localState"
            @localStateChange="handleLocalStateChange($event)"
            :find-a-store-text="findAStoreText"
            :buy-online-text="buyOnlineText"
            :local-is-loaded="localIsLoaded"
          />
          <template v-if="localState === 'online'">
            <local-product-list-item
              v-for="(
                { stock, price, logo, goUrl, name }, index
              ) in productsLimited"
              :key="index"
              :name="name"
              :price="price"
              :showPrice="settings.showPrice"
              :stock="stock"
              :logo="logo"
              :goUrl="`${goUrl}&cid=${cid}`"
              :inStockText="settings.inStockText"
              :outOfStockText="settings.outOfStockText"
              :currencySymbol="settings.currencySymbol"
            />
          </template>
          <template v-if="localState === 'offline' && localIsLoaded">
            <!-- gmaps is already only loaded when visible -->
            <local-offline-map
              :local-data="localRetailers"
              :custom-icon="customIcon"
              :starting-lat="startingLat"
              :starting-lng="startingLng"
              :starting-zoom="startingZoom"
              :enable-clustering="enableClustering"
              :disclaimer="disclaimer"
            />
          </template>
        </local-products-popup>
      </template>

      <template v-if="type === 'Remote local popup'">
        <local-products-popup
          :is-active="showRemoteLocalPopup"
          @on-close="toggleRemoteLocalPopup"
        >
          <local-online-offline-tab
            v-if="localIsLoaded"
            :state="localState"
            @localStateChange="handleLocalStateChange($event)"
            :find-a-store-text="findAStoreText"
            :buy-online-text="buyOnlineText"
            :local-is-loaded="localIsLoaded"
          />
          <template v-if="localState === 'online'">
            <local-product-list-item
              v-for="(
                { stock, price, logo, goUrl, name }, index
              ) in productsLimited"
              :key="index"
              :name="name"
              :price="price"
              :showPrice="settings.showPrice"
              :stock="stock"
              :logo="logo"
              :goUrl="`${goUrl}&cid=${cid}`"
              :inStockText="settings.inStockText"
              :outOfStockText="settings.outOfStockText"
              :currencySymbol="settings.currencySymbol"
            />
          </template>
          <template v-if="localState === 'offline' && localIsLoaded">
            <!-- gmaps is already only loaded when visible -->
            <local-offline-map
              :local-data="localRetailers"
              :custom-icon="customIcon"
              :starting-lat="startingLat"
              :starting-lng="startingLng"
              :starting-zoom="startingZoom"
              :enable-clustering="enableClustering"
              :disclaimer="disclaimer"
            />
          </template>
        </local-products-popup>
      </template>
    </template>
  </div>
</template>

<script>
import store from './store'
import { mapActions, mapGetters } from 'vuex'

import ProductsPopup from '@/components/popup/ProductsPopup'
import ProductsPopupItem from '@/components/popup/ProductListItem'

import LocalProductsPopup from '@/components/localPopup/localProductsPopup'
import LocalProductListItem from '@/components/localPopup/localProductListItem'
import LocalOnlineOfflineTab from '@/components/localPopup/localOnlineOfflineTab'
import LocalOfflineMap from '@/components/localPopup/localOfflineMap'

import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyABM-Sxvlj6UcdZqvU60KCZtwYQ5mjQTCU',
    libraries: 'places,geometry',
  },
  // installComponents: false,
})

export default {
  name: 'VendieWidget',
  props: {
    gtin: {
      require: true,
      type: String,
    },
    'm-id': {
      default: null,
      type: String,
    },
  },
  options: {
    props: {},
  },
  components: {
    ProductsPopup,
    ProductsPopupItem,
    LocalProductsPopup,
    LocalProductListItem,
    LocalOnlineOfflineTab,
    LocalOfflineMap,
  },
  beforeCreate() {
    this.$store = store()
  },
  data: () => ({
    showPopup: false,
    showRemotePopup: false,
    showRemoteLocalPopup: false,
    localRetailers: [],
    localState: 'online',
    localIsLoaded: false,
    cid: null, // string with cid, sid and gclid
    widgetVisible: false,
    localStoreLocatorTabVisible: false,
  }),
  computed: {
    ...mapGetters({
      products: 'products',
      settings: 'settings',
      extraCss: 'extraCss',
      localData: 'localData',
      error: 'error',
    }),
    type: ({ settings }) => settings.widgetType,
    productsLimited: ({ products, settings }) => {
      if (
        typeof settings.numberOfRetailers !== 'undefined' &&
        Number(settings.numberOfRetailers)
      ) {
        return products.slice(0, Number(settings.numberOfRetailers))
      }

      return products
    },
  },
  watch: {
    showPopup: function () {
      if (this.showPopup) this.fetchAndSetLocalData()
    },
    showRemoteLocalPopup: function () {
      if (this.showRemoteLocalPopup) this.fetchAndSetLocalData()
    },
  },
  async mounted() {
    await this.fetchProducts({
      gtin: this.gtin,
      manId: this['mId'], // Vue converts m-id to camelcase mId
    })
    window.vendie = this

    this.handleCookies()

    this.handleClientDomForRemoteButton()
  },
  methods: {
    ...mapActions({
      fetchProducts: 'fetchProducts',
      fetchLocalData: 'fetchLocalData',
    }),
    handleCookies(counter = 0) {
      // This function extracts marketing cookies and adds it to an encoded string
      // Cookies might have a delay so it tries for 6 seconds
      let intervalId = setInterval(() => {
        // console.log('Counter value:', counter)
        const SECONDS_TO_COUNT = 6
        let cookies = document.cookie.split('; ')
        let cid = '',
          sid = '',
          gclid = '',
          gaFound = false

        // Extraction and formatting
        try {
          for (let cookie of cookies) {
            let [name, value] = cookie.split('=')
            if (name === '_ga') {
              const gaParts = value.split('.')
              cid =
                gaParts[gaParts.length - 1] + '.' + gaParts[gaParts.length - 2]
              gaFound = true
            } else if (name.startsWith('_ga_') && value.startsWith('GS')) {
              sid = value.split('.')[2]
              gaFound = true
            } else if (name === '_gcl_aw') {
              gclid = value.split('.').reverse()[0]
            } else if (name === 'vendie_consent') {
              if (value === 'denied') {
                // Return early, before cid can be set
                clearInterval(intervalId) // Clear the interval if 'vendie_consent' is not 'granted'
                return
              }
            }
          }
          if (!gaFound) {
            counter++
            if (counter === SECONDS_TO_COUNT) {
              // console.log('GA not found after x seconds, returning')
              clearInterval(intervalId) // Clear the interval if no '_ga_' cookie or 'vendie_consent' is found after 6 attempts
            }
            return // Return full function, because ga cookies are not found within the set number of seconds
          }
          const cidString = `cid=${cid}&sid=${sid}&gclid=${gclid}`
          const encodedCidString = encodeURIComponent(cidString)
          this.cid = encodedCidString
          clearInterval(intervalId) // Clear the interval if we have found '_ga_' cookie and 'vendie_consent'
        } catch (err) {
          // do nothing
        }
      }, 1000) // Here we are checking for cookies every second. You can adjust the timing as per your requirements
    },
    async fetchAndSetLocalData() {
      // lazy load gmaps and local endpoint upon opening popup
      const localPopupVisible = this.showPopup && this.type === 'Local popup'
      const remoteLocalPopupVisible =
        this.showRemoteLocalPopup && this.type === 'Remote local popup'
      if (
        (localPopupVisible || remoteLocalPopupVisible) &&
        !this.localIsLoaded
      ) {
        await this.fetchLocalData({ manId: this['mId'] })
        this.localRetailers = this.localData.localretailers
        this.customIcon = this.localData.customicon
        this.startingLat = this.localData.startinglat
        this.startingLng = this.localData.startinglng
        this.startingZoom = this.localData.startingzoom
        this.findAStoreText = this.localData.findastoretext
        this.buyOnlineText = this.localData.buyonlinetext
        this.enableClustering = this.localData.enableclustering
        this.disclaimer = this.localData.disclaimer
        this.localIsLoaded = true
        // !!! if no valid local data is found, revert back to regular popup
      }
    },
    togglePopup() {
      this.showPopup = !this.showPopup
      if (this.showPopup) {
        this.dataLayerPushVendiePopupOpen()
      }
    },
    toggleRemotePopup() {
      this.showRemotePopup = !this.showRemotePopup
      if (this.showPopup) {
        this.dataLayerPushVendiePopupOpen()
      }
    },
    toggleRemoteLocalPopup() {
      this.showRemoteLocalPopup = !this.showRemoteLocalPopup
    },
    handleLocalStateChange(newLocalState) {
      if (!this.localStoreLocatorTabVisible) {
        this.localStoreLocatorTabVisible = true
        this.dataLayerPush('vendie_store_locator_open', {})
      }
      this.localState = newLocalState
    },
    handleClientDomForRemoteButton() {
      // hide buttons if no products are available
      if (!this.products || this.products.length === 0) {
        const vendieProductButtons = document.querySelectorAll(
          `#vendie-btn[gtin="${this.gtin}"], .vendie-btn[gtin="${this.gtin}"]`
        )

        vendieProductButtons.forEach((button) => {
          button.style.display = 'none'
        })

        // show fallback if available
        const vendieFallbackElements = document.querySelectorAll(
          `#vendie-fallback[gtin="${this.gtin}"], .vendie-fallback[gtin="${this.gtin}"]`
        )

        vendieFallbackElements.forEach((button) => {
          button.style.display = ''
        })
        // checking if remote popup again since above if can be no data or no products

        return
      }
      this.dataLayerPush('vendie_loaded', {})

      if (this.type === 'Remote popup') {
        // set event listener if products are available
        const vendieProductButtons = document.querySelectorAll(
          `#vendie-btn[gtin="${this.gtin}"], .vendie-btn[gtin="${this.gtin}"]`
        )

        // Check visibility on page load and on scrolls
        this.checkVisibility(vendieProductButtons)
        window.addEventListener('scroll', () => {
          this.checkVisibility(vendieProductButtons)
        })

        vendieProductButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.toggleRemotePopup()
          })
        })
      }

      if (this.type === 'Remote local popup') {
        // set event listener if products are available
        const vendieProductButtons = document.querySelectorAll(
          `#vendie-btn[gtin="${this.gtin}"], .vendie-btn[gtin="${this.gtin}"]`
        )

        // Check visibility on page load and on scrolls
        this.checkVisibility(vendieProductButtons)
        window.addEventListener('scroll', () => {
          this.checkVisibility(vendieProductButtons)
        })

        vendieProductButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.toggleRemoteLocalPopup()
          })
        })
      }

      // dataLayer visibility for non-remove widget
      if (this.type === 'Popup' || this.type === 'Local popup') {
        const shadowHost = document.querySelector('vendie-widget')
        if (!shadowHost) return
        const shadowRoot = shadowHost.shadowRoot
        const vendieProductButtons = shadowRoot.querySelectorAll(
          '.vendie-wtb-button'
        )

        // Check visibility on page load and on scrolls
        this.checkVisibility(vendieProductButtons)
        window.addEventListener('scroll', () => {
          this.checkVisibility(vendieProductButtons)
        })
      }
    },
    dataLayerPush(eventName, keyVals) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: eventName,
        ...keyVals,
      })
    },
    dataLayerPushVendiePopupOpen() {
      this.dataLayerPush('vendie_popup_open', {})
    },
    isElementInViewport(el) {
      const rect = el.getBoundingClientRect()
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      )
    },
    checkVisibility(buttons) {
      // Only one dataLayer event needed
      if (!this.widgetVisible) {
        buttons.forEach((button) => {
          if (this.isElementInViewport(button)) {
            if (this.widgetVisible === false) {
              this.dataLayerPush('vendie_button_visible', {})
            }
            this.widgetVisible = true
          }
        })
      }
    },
  },
}
</script>

<style>
.vendie-wtb-button,
.via-list,
.via-modal {
  font-family: sans-serif;
}

.vendie-wtb-button:hover {
  cursor: pointer;
}

/* 636px is height of local widget */
@media all and (max-height: 636px) {
  .via-modal {
    align-items: unset !important;
  }
  .via-modal-content {
    margin: auto !important;
  }
}
</style>
